import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import Skeleton from "@material-ui/lab/Skeleton";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

import { withStyles } from "@material-ui/core/styles";
import styles from "../../../styles/dashComponentStyles/Table/TableBodyStyle";

function LoadingTable(props) {
    const { classes, cols, rows } = props;

    let TableRows = [];
    let TableCells = [];

    for (let j = 0; j < cols; j++) {
        TableCells.push(
            <TableCell key={j} className={classes.loadingCell}>
                <Skeleton height={12} />
            </TableCell>
        );
    }

    for (let i = 0; i < rows; i++) {
        TableRows.push(<TableRow key={i}>{TableCells}</TableRow>);
    }

    return <TableBody>{TableRows}</TableBody>;
}

LoadingTable.propTypes = {
    classes: PropTypes.object,
    cols: PropTypes.number,
    rows: PropTypes.number,
};

export default withStyles(styles)(LoadingTable);
